export function isFailed (response) {
  if (response.data.errors) {
    console.warn('response.data.errors is has at least one error', response.data)
    return true
  }

  if (!response.data.success) {
    console.warn('response.data.success is false', response.data)
    return true
  }
  return false
}

export function deepClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function createTableHeaderHelp (h, title, body, trigger, placement, width, customClass) {
  let popover = h(
    'el-popover',
    {
      props: {
        'placement': placement,
        'title': title,
        'width': width,
        'trigger': trigger,
        'content': body,
        'popper-class': customClass
      },
    },
    [
      h(
        'i',
        {
          slot: 'reference',
          class: 'el-icon-info'
        }
      )
    ]
  )
  return h('span', [h('span', {style: 'padding-right: 8px'}, title), popover])
}

export async function axiosWrapper (promise) {
  let response
  try {
    response = await promise
  } catch (exc) {
    if (exc.response === undefined) {
      throw new RequestError({message: 'Connection Error'}) // no response at all
    }
    if (typeof exc.response.data !== 'object') {
      throw new RequestError({message: 'Server & DataFormat Error'}) // non-json response
    }
    throw new RequestError(exc.response.data)
  }
  let data = response.data
  if (typeof data !== 'object') {
    throw new RequestError({message: 'Data Format Error'}) // non-json response
  }
  if (data.success !== true) {
    if (!data.message) {
      data.message = 'Request was not successful'
    }
    throw new RequestError(data)
  }
  return data
}

function RequestError (response, message) {
  message = message || 'Request error'
  const error = new Error(message)
  error.response = response
  return error
}

RequestError.prototype = Object.create(Error.prototype)
